import stationHelper from '@packs/pages/diagrams/tiete_river/helpers/station_helper'
import store from '@packs/pages/diagrams/tiete_river/store/store'
import measurements_helper from '../../../../helpers/measurement_helper'
import dam_helper from '@packs/pages/diagrams/tiete_river/helpers/dam_helper'

import('./value_box.css')

export default function ValueBox(opts={}){
    BaseConstructor.call(this)
    let container = opts.container
    let elements = {}
    let context = this
    let {options, path} = opts
    let line_path, _circle
    let showing_value, currentShowing
    let current_line_path_position
    let showing_values = {}
    const CIRCLE_OPTIONS = {
        radius: 3,
        color:'var(--dark)'
    }

    const LINE_OPTIONS = {
        color: 'var(--dark)',
        width: '1px'
    }

    this.generate = () =>{
        elements.container = this.createElement('div', `box-value-sm box-value-container ${options.value_type && options.value_type.includes('rain') ? 'rain' : ''}`, '')
        elements.wrapper = this.createElement('div', 'box-value-wrapper', '')
        elements.value = this.createElement('div', 'box-value-item box-value-value', options.value)
        elements.icon = this.createElement('div', 'box-value-item  box-value-info box-value-icon', '<i class="fas fa-equals"></i>')
        elements.type = buildTypeElement()
        elements.delay = this.createElement('div', 'box-value-delay', '')
        elements.text = this.createElement('div', 'box-value-text', 'Chuva')
        elements.name = this.createElement('div', 'box-value-name', '')
        elements.maxmin = this.createElement('div', 'box-value-maxmin', '')

        $(elements.container).attr('draggable', true)

        $(elements.wrapper).append(elements.delay,elements.value, elements.icon, elements.type)

        $(elements.container).append(elements.wrapper)

        if(options.value_type && options.value_type.includes('rain')){
            $(elements.container).append(elements.text)
        }

        $(elements.container).prepend(elements.name)
        $(elements.container).append(elements.maxmin)

        
        $(document.body).append(elements.container)

        if(options.line){
            createCircle()
            createLine()
            setLineCirclePosition(options.line)
            $(container).append(_circle,line_path)
        }

        setPosition()

        //caixas de vazão serão escondidas até a seleçção de dados de vazão pelo usuário
        controlVisibility()

        eventsHandler()
        
    }

    this.update = () =>{

    }

    const buildTypeElement = () =>{
        return this.createElement('div', `box-value-item  box-value-info box-value-type ${(options.value_type && options.value_type.includes('rain'))? 'rain' : ''}`, getType())
    }

    const getType = _ =>{
        let data_show = store.mainConfigStore.getDataShow()

        if(!options.value_type){
            return 'm'
        } else if(data_show.flow && options.value_type.includes('flow')){
            return 'm³/s'
        } else if(data_show.rain && options.value_type.includes('rain')) {
            return 'mm'
        }
    }

    const eventsHandler = _ =>{
        store.stationStore.subscribe('SET_STATION_MEASUREMENTS', data=>{
            //verificando se são medições relacionadas a esse posto
            updateBoxState(data)
        })

        store.stationStore.subscribe('SET_STATION_PROP', data =>{
            if(data.station_id == options.station_id && data.prop == 'reference_values'){
                updateBoxColor(options.station_id)
                manageBoxName()
                manageMaxMin()
            }
        })

        store.stationStore.subscribe('SET_STATION_DELAY_STATUS', data=>{
            let {station_id, status} = data
            if(station_id == options.station_id){
                let station = store.stationStore.getStation(station_id)
                $(elements.delay).toggle(status == 'ATRASADO' || status == 'AGUARDANDO')
                $(elements.delay).css({
                    color: status == 'ATRASADO' ? 'red' : status == 'AGUARDANDO' ? 'yellow' : 'gray'
                })
                manageBoxName()
                
            }
            
        })

        //analisando atualizações no diagrama (interessado na mudança do numero de comportas abertas caso box seja relacionada a DAM)
        if(options.dam_id){
            store.damStore.subscribe('SET_DAM_EVENT', data=>{
                updateBoxState({
                    station_id: options.station_id,
                    measurements: store.stationStore.getStation(options.station_id).measurements
                })
            })
        }

        store.mainConfigStore.subscribe('SET_DATA_SHOW', data=>{
            controlVisibility()
            if(currentShowing){
                let station = store.stationStore.getStation(options.station_id)
                updateBoxState({
                    station_id: options.station_id || options.station_ids,
                    measurements: station ? store.stationStore.getStation(options.station_id).measurements : []
                })
                setPosition()
            }
            $(elements.type).html(getType())
        })
        
        
        $(elements.container).on('click', _ =>{
            
            store.informationCardStore.setDamId(options.dam_id || undefined)
            store.informationCardStore.setDataType(options.value_type || ['level'])
            store.informationCardStore.setTitle(options.name)
            store.informationCardStore.setObjType('station')
            store.informationCardStore.setStationId(options.station_id || options.station_ids)
            
            store.informationCardStore.updateCardPosition(elements.container)
        })
        $(elements.container).on('mouseleave', _ =>{
            // store.informationCardStore.setStationId(undefined)
        })

        store.diagramStore.subscribe('PATH_UPDATE_POSITION', _path=>{
            if(_path ===path){
                if(options.line){
                    setLineCirclePosition(options.line)
                }
                setPosition()
            }
        })

        store.mainConfigStore.subscribe('SET_CONFIG', data=>{
            let station = store.stationStore.getStation(options.station_id)
            if(data.path === 'show_max_min'){
                updateBoxState({
                    station_id: options.station_id || options.station_ids,
                    measurements: station ? store.stationStore.getStation(options.station_id).measurements : []
                })
            } else if(data.path === 'show_station_name'){
                manageBoxName()
            }
        })

        $(elements.container).on('dragend', (e) =>{
            setLineCirclePosition(options.line, {x: e.originalEvent.clientX, y: e.originalEvent.clientY})
            setPosition()
        })
        

        
    }

    const updateBoxColor = station_id =>{        
        let status = stationHelper.referenceByValue(station_id, showing_values[station_id]*100);
        if(status){
            let colors = stationHelper.colorByReference(status)
            
            $(elements.container).css({
                border: `1px solid ${colors.full}`,
                backgroundColor: colors.light
            })
        } else {
            $(elements.container).css({
                border: `1px solid white`,
                backgroundColor: 'white'
            })
        }
    }

    const updateBoxState = (data) =>{
        if(data.station_id == options.station_id){
            let VALUE, measurements = data.measurements
            if(measurements.length > 0){
                
                //organizando por data
                measurements = measurements.sort((a,b) => new Date(b.date) - new Date(a.date))

                //configurações de exibição presentes na mainConfig
                let data_show = store.mainConfigStore.getDataShow()

                //verificando se o cliente esta exibindo nivel ou vazão
                if(data_show.flow && (options.value_type && options.value_type.includes('flow'))){
                    //aqui exibir vazão (já calculada equações recebidas)
                    VALUE = measurements[0].read_value 

                    //caso relacionado com barragem, multiplicar a vazão pelo numero de comportas abertas
                    if(options.dam_id){
                        //lista de comportas da barragem
                        let gates = dam_helper.getDamGates(options.dam_id) || dam_helper.getDamDefaultGates(options.dam_id)
                        if(gates){
                            //multiplicando vazão pelo número de comportas
                            VALUE = (VALUE * (Object.values(gates).filter(x=>x.status === 'true' || x.status === true).length)).toFixed(3)
                        }
                    }
                    
                } else{
                    //aqui exibir nível
                    manageMaxMin()
                    
                    if(store.mainConfigStore.getPeriod().retro){
                        let max = _.maxBy(measurements, 'value')
                        VALUE = (max.value/100 ).toFixed(3)
                    } else {
                        VALUE = (measurements[0].value/100 ).toFixed(3)
                    }
                    
                }
                
            } else {
                //não tem medições
                VALUE = '-'
            }

            //adicionando valor no elemento que fica exibindo o valor do ponto
            elements.value.innerHTML = (VALUE)
            
            //facilitar acesso ao atual valor em outros métodos
            showing_value = VALUE
            showing_values[data.station_id] = VALUE
            
            if(measurements[1]){
                //exibindo icone de tendência caso possua uma medição anterior
                $(elements.icon).html(measurements[0].value > measurements[1].value ? '<i class="fas fa-long-arrow-alt-up"></i>' : measurements[0].value < measurements[1].value ? '<i class="fas fa-long-arrow-alt-down"></i>' : '<i class="fas fa-equals"></i>')
            }

            updateBoxColor(data.station_id)
        } else if(Array.isArray(options.station_ids) && options.station_ids.includes(data.station_id)){
            let SUM = 0, QTD = 0
            let timestamps = {}
            
            store.stationStore.getStationsByIds(options.station_ids).forEach(station=>{
                if(station.measurements && station.measurements.length > 0){
                    station.measurements.forEach(measurement=>{
                        timestamps[new Date(measurement.date).getTime()] = timestamps[new Date(measurement.date).getTime()] || []
                        timestamps[new Date(measurement.date).getTime()].push(measurement.value)
                    })
                }
            })
            
            SUM = Object.values(timestamps).map(x=> x.reduce((a,c) => a + c, 0) / x.length).reduce((a,c) => a + c, 0)

            elements.value.innerHTML = (SUM).toFixed(2)
        }
    }

    const manageBoxName = _ =>{
        let station = store.stationStore.getStation(options.station_id)
        if(station && store.mainConfigStore.getConfig('show_station_name')){
            $(elements.name).show()
            elements.name.innerHTML = station.station ? station.station.name.substring(0,20) : ''
        } else {
            $(elements.name).hide()
            elements.name.innerHTML = ''
        }
    }

    const manageMaxMin = () =>{
        
        let station = store.stationStore.getStation(options.station_id)

        const chevron = (direction) => {
            return `<span class='fas fa-chevron-${direction} mr-1'></span>`
        }
        let measurements = store.stationStore.getStation(options.station_id).measurements
        if(measurements && measurements.length > 0 && store.mainConfigStore.getConfig('show_max_min')){
            
            //pegando max min            
            let max = _.maxBy(measurements, 'value').value
            let min = _.minBy(measurements, 'value').value
            
            if(max || min){
                //exibindo o container
                $(elements.maxmin).addClass('show')

                //preenchendo o container de maxmin com os valores
                $(elements.maxmin).html(`<div>${chevron('down')}${(min ? (min/100).toFixed(3) : '-')}</div><div>${chevron('up')}${(max ? (max/100).toFixed(3) : '-')}</div>`)       
            } else {
                //escondendo o container
                $(elements.maxmin).removeClass('show')
            }
            
        } else {
            $(elements.maxmin).removeClass('show')
        } 

        
    }

    const getMaxMin = measurements =>{
        return {
            max: _.maxBy(measurements, 'value'),
            min: _.minBy(measurements, 'value')
        }
    }

    const controlVisibility = _ =>{
        let data_show = store.mainConfigStore.getDataShow()
        let show_flow = data_show.flow
        let show_rain = data_show.rain
        if(show_flow){
            
            if(options.value_type && options.value_type.includes('flow')){
                //show
                showBox()
            } else {
                hideBox()
                //hide
            }
            //apenas as vazões
        } else {
            if(!options.value_type || options.value_type.includes('level')){
                showBox()
            } else {
                hideBox()
            }
            //apenas os niveis
        }

        //exibindo chuva caso valido
        if(options.value_type && show_rain && options.value_type.includes('rain')){
            showBox()
        }
    }

    const hideBox = _ =>{
        currentShowing=false
        if(_circle){
            $(_circle).hide()
        }
        if(line_path){
            $(line_path).hide()
        }
        $(elements.container).hide()
    }

    const showBox = _ =>{
        currentShowing=true
        if(_circle){
            $(_circle).show()
        }
        if(line_path){
            $(line_path).show()
        }
        $(elements.container).show()
    }

    const createCircle = () => {
        _circle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
        _circle.setAttribute('r', CIRCLE_OPTIONS.radius)
        _circle.setAttribute("fill", CIRCLE_OPTIONS.color);
        _circle.setAttribute('opacity', options.line.show ? 1 : 0)
    }

    const createLine = () =>{
        line_path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        line_path.setAttribute('fill', 'none');
        line_path.setAttribute('stroke', LINE_OPTIONS.color);
        line_path.setAttribute('stroke-width', LINE_OPTIONS.width)
        line_path.setAttribute('stroke-dasharray', '4 1')
        line_path.setAttribute('opacity', options.line.show ? 1 : 0)
         
    }

    const setLineCirclePosition = (line_options, to) =>{

        let bbox = path ? path.getBBox() : undefined
        let x, y, x_to, y_to
        if(bbox){
            let vertical = (bbox.height)? true : false
            x = vertical ? bbox.x : bbox.x + convertPosition(path, options.position.value)
            y = vertical ? bbox.y + convertPosition(path, options.position.value) : bbox.y
        } else {
            x = options.position.x
            y = options.position.y
        }
        
        if(line_options.position.direction === 'down'){
            y_to = y + convertPosition(path, line_options.position.size)
            x_to = x
        } else if(line_options.position.direction === 'right'){
            y_to = y
            x_to = x + convertPosition(path, line_options.position.size)
        } else if(line_options.position.direction === 'left'){
            y_to = y
            x_to = x - convertPosition(path, line_options.position.size)
        } else if(line_options.position.direction === 'up'){
            y_to = y - convertPosition(path, line_options.position.size)
            x_to = x
        }
        
        if(!to){
            line_path.setAttribute('d', `M ${x} ${y} ${x_to} ${y_to} `);
        } else {
            
            //'to' seria uma posição ja definida. espera-se um valor absoluto do clientX/clientY
            line_path.setAttribute('d', `M ${x} ${y} ${to.x - $(container).offset().left} ${to.y- $(container).offset().top} `);
            
            //salvando a posição para usar em outros lugares
            current_line_path_position = [x, y, to.x, to.y]
        }
        

        _circle.setAttribute('cx', x)
        _circle.setAttribute('cy', y)
    }

    const setPosition = _ =>{

        let config = {
            position: 'absolute',
            top: 0,
            left: 0
        }

        if(line_path){ //grudar na linha
            
            let direction = options.line.position.direction
            let bbox = line_path.getBBox()
            let offset = $(line_path).offset()
            
            if(current_line_path_position){
                config.top = current_line_path_position[3] - $(elements.container).height()/2//y_to
                config.left = current_line_path_position[2] - $(elements.container).width()/2//x_to
                config.transform = `translate(0,0)`
                // config.transform = `translate(${direction === 'down' || direction === 'up' ? '-50' : direction === 'left' ? '-100' : '0'}%, ${direction === 'left' || direction === 'right' ? '-50' : direction === 'up' ? '-100' : '0'}%)`
            } else {
                config.top = (direction === 'down') ? offset.top + (bbox.width || bbox.height) : offset.top
                config.left = (direction === 'right') ? offset.left + (bbox.width || bbox.height) : (direction === 'left') ?  offset.left - (0) : offset.left
                config.transform = `translate(${direction === 'down' || direction === 'up' ? '-50' : direction === 'left' ? '-100' : '0'}%, ${direction === 'left' || direction === 'right' ? '-50' : direction === 'up' ? '-100' : '0'}%)`
            }

            

        } else {
            if(path){
                let path_bbox = path.getBBox()
                let offset = $(path).offset()
                let horizontal = path_bbox.width ? true : false

                config.top = !horizontal ? offset.top + convertPosition(path, options.position.value, 'h') : offset.top,
                config.left = offset.left
            } else {
                config.left = options.position.x
                config.top = options.position.y
            }
            
        }

        $(elements.container).css({
            ...config
        })

        
    }

    const convertPosition = (path, pos, type) =>{
        if(path){
            let box = path.getBBox() //status do path
            return pos * (box.height || box.width) / 100 //convertendo porcentagem em pixel
        } else {
            let container_w = $(container).width()
            let container_h = $(container).height()
            if(type == 'w'){
                return pos * container_w / 100
            } else {
                return pos * container_h / 100
            }
        }
        
    }
}

ValueBox.prototype = Object.create(BaseConstructor.prototype)